export enum MedicalIndicatorsEnum {
    Ok = "Ok",
    High = "High",
    Low = "Low",
}